import { populate } from 'populate';

const raw = {
    width: 640,
    height: 960,
    x: 0,
    y: 0,
    list: [
        {
            id: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            type: 'Container',
            name: 'root',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '',
            data: '',
        },
        {
            id: '02444825-d5d9-4a4a-8760-3084104d3628',
            type: 'Sprite',
            name: 'eventBG',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_remove_suit_spades',
            parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            data: '',
        },
        {
            id: 'fab47d33-68e9-4fca-acfd-769fab89c177',
            type: 'Sprite',
            name: 'loadingContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 0,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_timer_panel',
            parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            data: '',
        },
        {
            id: '1633d141-60e9-4080-9f2a-a013ce93f04d',
            type: 'Sprite',
            name: 'cooldownContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 0,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_timer_panel',
            parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            data: '',
        },
        {
            id: 'ef3af323-52b4-4323-829c-543ad87ca71a',
            type: 'Container',
            name: 'activeContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '02444825-d5d9-4a4a-8760-3084104d3628',
            data: '',
        },
        {
            id: '29639e08-af28-4c3f-962f-504dee1e1611',
            type: 'Sprite',
            name: 'completedContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blank',
            parent: '02444825-d5d9-4a4a-8760-3084104d3628',
            data: '',
        },
        {
            id: '71437bf6-3909-412f-81c5-13c6caf940fe',
            type: 'Text',
            name: 'loadingText',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'Loading',
            localize: true,
            maxWidth: 0,
            maxHeight: 0,
            maxFontSize: 0,
            icons: [],
            style: {
                fontSize: 24,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: '#a3705e',
                stroke: 'black',
                strokeThickness: 0,
                align: 'left',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'round',
                miterLimit: 10,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: 'fab47d33-68e9-4fca-acfd-769fab89c177',
            data: '',
        },
        {
            id: '80c2ba1b-0e4f-4cbe-aff4-2655357f545f',
            type: 'Container',
            name: 'cooldownDBContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: -85,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '1633d141-60e9-4080-9f2a-a013ce93f04d',
            data: '',
        },
        {
            id: '4cb60317-e93e-4ee8-ae69-62eb690b6a3e',
            type: 'Text',
            name: 'cooldownText',
            nameSpace: '',
            className: '',
            x: 0,
            y: 10,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 0,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'NewMissionComing',
            localize: true,
            maxWidth: 260,
            maxHeight: 46,
            maxFontSize: 24,
            icons: [],
            style: {
                fontSize: 24,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: '#a3705e',
                stroke: 'black',
                strokeThickness: 0,
                align: 'left',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'round',
                miterLimit: 10,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: '1633d141-60e9-4080-9f2a-a013ce93f04d',
            data: '',
        },
        {
            id: 'baa80293-5d57-453e-a035-79dee2be4a7f',
            type: 'Text',
            name: 'timerText',
            nameSpace: '',
            className: '',
            x: 0,
            y: 45,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 0,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: '99:99:99',
            localize: false,
            maxWidth: 263,
            maxHeight: 56,
            maxFontSize: 33,
            icons: [],
            style: {
                fontSize: 33,
                fontWeight: 'normal',
                fontFamily: 'ArchivoBlack',
                fill: '#FFFFFF',
                stroke: '#a3705e',
                strokeThickness: 5,
                align: 'left',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'round',
                miterLimit: 10,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 3,
            },
            parent: '1633d141-60e9-4080-9f2a-a013ce93f04d',
            data: '',
        },
        {
            id: '32b0fc25-9c3d-4dce-8038-8fa3b7b6fa37',
            type: 'Sprite',
            name: 'bgGlow',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_panel_glow',
            parent: 'ef3af323-52b4-4323-829c-543ad87ca71a',
            data: '',
        },
        {
            id: 'e5535388-1a25-412b-a71b-58f606fa8230',
            type: 'Sprite',
            name: 'bgActive',
            nameSpace: '',
            className: '',
            x: 0,
            y: 100,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_panel_bg',
            parent: 'ef3af323-52b4-4323-829c-543ad87ca71a',
            data: '',
        },
        {
            id: '24074e44-8980-4455-a3ec-8afe3481a889',
            type: 'Sprite',
            name: 'bgShiny',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 0,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_effect',
            parent: 'ef3af323-52b4-4323-829c-543ad87ca71a',
            data: '',
        },
        {
            id: '94c14cf2-b6f9-44a3-ab9c-572babf33fb3',
            type: 'Sprite',
            name: 'bgCompleted',
            nameSpace: '',
            className: '',
            x: 0,
            y: 99,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_panel_gold',
            parent: 'ef3af323-52b4-4323-829c-543ad87ca71a',
            data: '',
        },
        {
            id: '4461311d-eca8-490c-8050-5e06231e181a',
            type: 'Text',
            name: 'questTitle',
            nameSpace: '',
            className: '',
            x: 0,
            y: 20,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'Collect 10 stars',
            localize: false,
            maxWidth: 220,
            maxHeight: 55,
            maxFontSize: 22,
            icons: [],
            style: {
                fontSize: 22,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: 'white',
                stroke: '#8c3d35',
                strokeThickness: 5,
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 220,
                breakWords: false,
                lineHeight: 20,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'miter',
                miterLimit: 2,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: 'ef3af323-52b4-4323-829c-543ad87ca71a',
            data: '',
        },
        {
            id: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
            type: 'Sprite',
            name: 'progressBar',
            nameSpace: '',
            className: '',
            x: 0,
            y: 68,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_bar_back',
            parent: 'ef3af323-52b4-4323-829c-543ad87ca71a',
            data: '',
        },
        {
            id: 'b4763103-c45b-450e-8023-22c36aebf4c8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 110,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_prize_back',
            parent: 'ef3af323-52b4-4323-829c-543ad87ca71a',
            data: '',
        },
        {
            id: 'a2d1962c-f762-46c7-8567-3994a609ef12',
            type: 'Container',
            name: 'completedDBContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: 72,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '29639e08-af28-4c3f-962f-504dee1e1611',
            data: '',
        },
        {
            id: '515f385c-e702-409a-8e8e-cf6e459afffd',
            type: 'Text',
            name: 'completeText',
            nameSpace: '',
            className: '',
            x: -50,
            y: 125,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 0,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'Completed',
            localize: true,
            maxWidth: 0,
            maxHeight: 0,
            maxFontSize: 0,
            icons: [],
            style: {
                fontSize: 30,
                fontWeight: 'normal',
                fontFamily: 'ArchivoBlack',
                fill: 'white',
                stroke: '#8c3d35',
                strokeThickness: 5,
                align: 'center',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'miter',
                miterLimit: 2,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: '29639e08-af28-4c3f-962f-504dee1e1611',
            data: '',
        },
        {
            id: 'dccef640-4c55-4b6a-9999-7d8fc03d41a9',
            type: 'Sprite',
            name: 'collectButton',
            nameSpace: '',
            className: '',
            x: 0,
            y: 170,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.9,
                y: 0.9,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: true,
            buttonMode: true,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_collect',
            parent: '94c14cf2-b6f9-44a3-ab9c-572babf33fb3',
            data: '',
        },
        {
            id: 'b6ce9e71-663f-4870-b606-76380e1c3c42',
            type: 'NineSlicePlane',
            name: 'progressBarFill',
            nameSpace: '',
            className: '',
            x: 1,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 121,
                y: 20,
            },
            width: 241,
            height: 40,
            leftWidth: 16,
            topHeight: 8,
            rightWidth: 16,
            bottomHeight: 8,
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_bar_green',
            parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
            data: '',
        },
        {
            id: '861ee79b-893e-4894-9ed3-9aaf1cc6db5b',
            type: 'NineSlicePlane',
            name: 'progressBarFillShiny',
            nameSpace: '',
            className: '',
            x: -2,
            y: 0,
            scale: {
                x: -1,
                y: 1,
            },
            pivot: {
                x: 121,
                y: 20,
            },
            width: 241,
            height: 40,
            leftWidth: 16,
            topHeight: 8,
            rightWidth: 16,
            bottomHeight: 8,
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_bar_green',
            parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
            data: '',
        },
        {
            id: '329ba0b9-30ee-4be2-808f-7cabd9cc9d84',
            type: 'Sprite',
            name: 'progressBarFrontSprite',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_bar_front',
            parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
            data: '',
        },
        {
            id: '80393e63-9adc-4510-9fd5-e13c0991e981',
            type: 'Text',
            name: 'progressText',
            nameSpace: '',
            className: '',
            x: 0,
            y: -1,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: '23 / 100',
            localize: false,
            maxWidth: 139,
            maxHeight: 40,
            maxFontSize: 26,
            icons: [],
            style: {
                fontSize: 26,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: 'white',
                stroke: '#0282C5',
                strokeThickness: 5,
                align: 'left',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'round',
                miterLimit: 10,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
            data: '',
        },
        {
            id: '0718b2c1-21cc-4cae-8652-ff5d064155ec',
            type: 'Container',
            name: 'rewardDBContainer',
            nameSpace: '',
            className: '',
            x: -40,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: 'b4763103-c45b-450e-8023-22c36aebf4c8',
            data: '',
        },
        {
            id: '44a4a841-9122-4f7b-80aa-2d5b0827feab',
            type: 'Sprite',
            name: 'rewardSprite',
            nameSpace: '',
            className: '',
            x: -40,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_prize_joker',
            parent: 'b4763103-c45b-450e-8023-22c36aebf4c8',
            data: '',
        },
        {
            id: '08a246ad-6fab-4707-bd9b-e4a24150dddd',
            type: 'Text',
            name: 'rewardText',
            nameSpace: '',
            className: '',
            x: 0,
            y: -1,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: '1',
            localize: false,
            maxWidth: 48,
            maxHeight: 30,
            maxFontSize: 27,
            icons: [],
            style: {
                fontSize: 27,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: 'white',
                stroke: '#a33f2b',
                strokeThickness: 5,
                align: 'left',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'round',
                miterLimit: 10,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: 'b4763103-c45b-450e-8023-22c36aebf4c8',
            data: '',
        },
        {
            id: '485bd1d7-6340-4f1d-a832-987a413706b1',
            type: 'Container',
            name: 'buttonDBContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: 'dccef640-4c55-4b6a-9999-7d8fc03d41a9',
            data: '',
        },
        {
            id: '11a7909b-3bb8-4e61-b2a5-2659a9bf0fcf',
            type: 'Text',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: -2,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'Collect',
            localize: true,
            maxWidth: 0,
            maxHeight: 0,
            maxFontSize: 0,
            icons: [],
            style: {
                fontSize: 32,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: '#ffffff',
                stroke: '#048506',
                strokeThickness: 5,
                align: 'left',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'round',
                miterLimit: 10,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: 'dccef640-4c55-4b6a-9999-7d8fc03d41a9',
            data: '',
        },
    ],
} as const;

export class QuestItemLayout {
    static raw = raw;
    root: GameObject<PIXI.Container>;
    eventBG: GameObject<PIXI.Sprite>;
    activeContainer: GameObject<PIXI.Container>;
    bgGlow: GameObject<PIXI.Sprite>;
    bgActive: GameObject<PIXI.Sprite>;
    bgShiny: GameObject<PIXI.Sprite>;
    bgCompleted: GameObject<PIXI.Sprite>;
    collectButton: GameObject<PIXI.Sprite>;
    buttonDBContainer: GameObject<PIXI.Container>;
    questTitle: GameObject<PIXI.Text>;
    progressBar: GameObject<PIXI.Sprite>;
    progressBarFill: GameObject<PIXI.NineSlicePlane>;
    progressBarFillShiny: GameObject<PIXI.NineSlicePlane>;
    progressBarFrontSprite: GameObject<PIXI.Sprite>;
    progressText: GameObject<PIXI.Text>;
    rewardDBContainer: GameObject<PIXI.Container>;
    rewardSprite: GameObject<PIXI.Sprite>;
    rewardText: GameObject<PIXI.Text>;
    completedContainer: GameObject<PIXI.Sprite>;
    completedDBContainer: GameObject<PIXI.Container>;
    completeText: GameObject<PIXI.Text>;
    loadingContainer: GameObject<PIXI.Sprite>;
    loadingText: GameObject<PIXI.Text>;
    cooldownContainer: GameObject<PIXI.Sprite>;
    cooldownDBContainer: GameObject<PIXI.Container>;
    cooldownText: GameObject<PIXI.Text>;
    timerText: GameObject<PIXI.Text>;

    constructor() {
        populate(this, raw);
    }
}
